<div class="wrapper">
  <div class="abs-center wd-xl text-center">
    <h3>Authenticating</h3>
    <v-loading-spinner></v-loading-spinner>
  </div>
</div>
